<template>
<div class="chapter">
<div class="inner_page">
<div id="cover">
<img alt="Seven Reasons Your Church Will Never Have Revival" class="cover-image" src="images/image-9781644577653.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// cover.vue?cee72d08